var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{staticClass:"loading-box",attrs:{"show":_vm.visible,"z-index":3001}},[_c('div',{staticClass:"wrapper",on:{"click":function($event){$event.stopPropagation();}}},[_c('van-loading',{attrs:{"size":"56px","text-size":"16px","vertical":""}},[(_vm.hasText)?_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }